import type { NeteaseTrackMetadata, ParsedTrack } from "@shared/types";

export type TrackIdentityStatus = "match" | "mismatch" | "unknown";

function normalizedText(value: string): string {
  return value
    .normalize("NFKC")
    .toLocaleLowerCase("en-US")
    .replace(/[^\p{L}\p{N}]+/gu, "");
}

function artistSet(value: string): Set<string> {
  return new Set(
    value
      .split(/\s*(?:,|，|、|\/|&|＆|;|；|\+|\bfeat(?:uring)?\.?\b|\bft\.?\b)\s*/iu)
      .map(normalizedText)
      .filter(Boolean),
  );
}

export function trackIdentityStatus(
  track: Pick<ParsedTrack, "title" | "artist">,
  metadata: NeteaseTrackMetadata | null,
): TrackIdentityStatus {
  if (!metadata?.resolvedTitle || metadata.resolvedArtists.length === 0) return "unknown";
  if (normalizedText(track.title) !== normalizedText(metadata.resolvedTitle)) return "mismatch";

  const submittedArtists = artistSet(track.artist);
  const resolved = new Set(metadata.resolvedArtists.map(normalizedText).filter(Boolean));
  if (submittedArtists.size !== resolved.size) return "mismatch";
  for (const artist of resolved) {
    if (!submittedArtists.has(artist)) return "mismatch";
  }
  return "match";
}

export function resolvedTrackLabel(metadata: NeteaseTrackMetadata | null): string {
  if (!metadata?.resolvedTitle || metadata.resolvedArtists.length === 0) {
    return "网易云未返回完整的歌名和歌手信息";
  }
  return `网易云：${metadata.resolvedTitle} — ${metadata.resolvedArtists.join(" / ")}`;
}
